import Player from '@vimeo/player';

var elementId = 'js_homepageHeroVideo',
    mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)"),
    globalVimeoPlayerContainer,
    globalVimeoPlayer,
    globalVimeoPlayerWidth,
    globalVimeoPlayerHeight,
    resizeDebounceTimer;

function homepageHeroVideo() {
    if (!(!mediaQuery || mediaQuery.matches)) {
        globalVimeoPlayerContainer = $('#'+elementId);

        if (
            $(globalVimeoPlayerContainer)[0] &&
            $(globalVimeoPlayerContainer).data('id')
        ) {
            globalVimeoPlayer = new Player(elementId, {
                id: $(globalVimeoPlayerContainer).data('id'),
                muted: true,
                background: true
            });
            var placeholder = $(globalVimeoPlayerContainer).find(".js_homepageHeroVideo__placeholder");

            Promise.all([globalVimeoPlayer.getVideoWidth(), globalVimeoPlayer.getVideoHeight()]).then(dimensions => {
                globalVimeoPlayerWidth = dimensions[0];
                globalVimeoPlayerHeight = dimensions[1];
                sizesForPlayer();
            });

            globalVimeoPlayer.on('play', function() {
                if ($(placeholder)) $(placeholder).css({"opacity": 0});
            });
        }
    }
}

function sizesForPlayer() {
    if (!(!mediaQuery || mediaQuery.matches)) {
        var iframe = $(globalVimeoPlayerContainer).find("iframe"),
            containerHeight = $(globalVimeoPlayerContainer).height(),
            containerWidth = $(globalVimeoPlayerContainer).width(),
            containerAspectRatio = containerHeight / containerWidth,
            playerAspectRatio = globalVimeoPlayerHeight / globalVimeoPlayerWidth

        if (playerAspectRatio > containerAspectRatio) {
            iframe.css({"width": "100%", "height": (containerWidth * playerAspectRatio) + "px"});
        } else {
            iframe.css({"width": ((containerHeight / (playerAspectRatio * 100)) * 100) + "px", "height": "100%"});
        }
    }
}

$(document).ready(function () {
    'use strict'

    homepageHeroVideo();
});

/*
 * Stop transitions on resize
 */
$(window).on('resize', function (e) {
    'use strict'

    clearTimeout(resizeDebounceTimer);
    resizeDebounceTimer = setTimeout(sizesForPlayer, 100);
});
